import { Pipe, PipeTransform } from '@angular/core';

import { TaxRegimeCode } from '@enums/tax-regime-code.enum';
import { TaxRegime } from '@models/tax-regime';

@Pipe({
  name: 'taxRegimeLabel',
  standalone: true
})
export class TaxRegimeLabelPipe implements PipeTransform {
  transform(taxRegimeCode: TaxRegimeCode, taxRegimes: TaxRegime[], condensed = true): string {
    if (!taxRegimeCode || !taxRegimes) {
      return '';
    }

    const foundedTaxRegimes = taxRegimes.find(taxRegime => taxRegime.code === taxRegimeCode);

    if (!foundedTaxRegimes) {
      return '';
    }

    if (condensed) {
      return foundedTaxRegimes.condensedLabel;
    }

    return foundedTaxRegimes.label;
  }
}
